import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import grey from '@material-ui/core/colors/grey';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio';
import Snackbar from '@material-ui/core/Snackbar';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { push } from 'connected-react-router';
import { ICareerInfo } from 'src/actions/search';
import SearchScenarioFactory from 'src/scenario/SearchScenarioFactory';
import * as Actions from '../actions/questionnaire';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ELearningScenarioFactory, {
	IFetchELearningProgressParam,
	IFetchELearningTreeParam,
} from '../scenario/ELearningScenarioFactory';
import ScenarioFactory, {
	IFetchQuestionnaireParam,
	ISaveQuestionnaireParam,
	IUpdateQuestionnaireParam,
} from '../scenario/QuestionnaireScenarioFactory';
import ReplaceStyleKeywords from '../utils/ReplaceStyleKeywords';
import { Routes, Screens } from '../utils/Routes';
import { funcClose } from '../utils/StartupUtils';
import { IQuestionnaireProps } from './ELearningQuestionnaire';

const styles = (theme: Theme) =>
	createStyles({
		blockTitle: {
			flexGrow: 1,
			fontSize: '1.2rem',
		},
		buttons: {
			marginTop: theme.spacing(2),
		},
		mustFlg: {
			color: '#FF0000',
			fontWeight: 'bold',
		},
		options: {
			backgroundColor: grey[100],
		},
		optionsTable: {
			width: 'fit-content',
		},
		questionnaire: {
			marginLeft: '1em',
		},
		radioCell: {
			textAlign: 'center',
		},
		root: {
			padding: theme.spacing(2),
			wordBreak: 'break-word',
		},
	});

interface IState {
	answers: { [questionnaireID: string]: number };
	disableReportButton: boolean;
	saveResultSnackbar: boolean;
	openReportConfirm: boolean;
	openReportResult: boolean;
	previewDisplayTmpSaveBtn: boolean;
	careerName: string;
	vendor: string;
}

interface IQuestionProps {
	questionnaire: Actions.IQuestionnaire;
	classes: IOwnProps['classes'];
	answerValue: number;
	options: Actions.IOption[];
	handleRadio: (event: React.MouseEvent<HTMLElement>) => void;
}

const Questionnaire = React.memo((props: IQuestionProps) => {
	const { questionnaire, classes, answerValue, options, handleRadio } = props;
	return (
		<TableRow key={questionnaire.questionnaireID}>
			<TableCell>
				{questionnaire.mustFlg === 1 && (
					<span className={classes.mustFlg}>＊</span>
				)}
				{questionnaire.mustFlg === 1 && (
					<>{questionnaire.questionnaireNo}</>
				)}
				{questionnaire.mustFlg !== 1 && (
					<span className={classes.questionnaire}>
						{questionnaire.questionnaireNo}
					</span>
				)}
			</TableCell>
			<TableCell>
				<span
					dangerouslySetInnerHTML={{
						__html: ReplaceStyleKeywords.replaceStyleKeywords(
							questionnaire.questionnaireText
						),
					}}
				/>
			</TableCell>
			{options.map(option => {
				const value = option.replyOrder as number;
				let checked = false;
				if (answerValue && answerValue === value) {
					checked = true;
				}
				return (
					<TableCell
						key={value}
						padding="none"
						className={classes.radioCell}
					>
						<Radio
							name={questionnaire.questionnaireID}
							value={value.toString()}
							onClick={handleRadio}
							checked={checked}
						/>
					</TableCell>
				);
			})}
		</TableRow>
	);
});

/**
 * アンケート表形式
 */
class QuestionnaireGrid extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			answers: {},
			careerName: '',
			disableReportButton: false,
			openReportConfirm: false,
			openReportResult: false,
			previewDisplayTmpSaveBtn: true,
			saveResultSnackbar: false,
			vendor: '',
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillReceiveProps(nextProps: IProps) {
		if (this.props.blocks === nextProps.blocks) {
			return;
		}

		// 回答データの初期化
		// サーバからのデータに回答が入っていた場合は反映する
		const answers = {};
		for (const block of nextProps.blocks) {
			for (const q of block.questionnaires) {
				answers[q.questionnaireID] = q.selectedReply;
			}
		}

		this.setState({
			answers,
		});
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.fetch();
		if (this.props.assessmentFlg) {
			this.props
				.doFetchCareerDetail(this.props.token, this.props.careerID)
				.then(data => {
					const careerInfo: ICareerInfo = data.careerInfo;
					this.setState({
						careerName: careerInfo.careerTitle || '',
						vendor: careerInfo.vendor || '',
					});
				});
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (
			prevProps.careerID === this.props.careerID &&
			prevProps.classID === this.props.classID &&
			prevProps.id === this.props.id
		) {
			return;
		}
		// アンケートから違うアンケートに遷移したときここにくる
		this.fetch();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.clearQuestionnaireParams();
	}

	public render() {
		return (
			<div className={this.props.classes.root}>
				<Typography variant="h6" gutterBottom={true}>
					{this.props.assessmentFlg
						? this.state.careerName
						: this.props.enqueteName}
				</Typography>
				{this.props.assessmentFlg && this.state.vendor && (
					<Typography variant="h6" align={'center'}>
						{i18n.t('QuestionnaireGrid_0001', {
							vendor: this.state.vendor,
						})}
					</Typography>
				)}
				<this.Options />
				{this.props.blocks.map(block => (
					<this.Block key={block.blockID} block={block} />
				))}
				{this.props.periodJudgment !== 2 && <this.Buttons />}
			</div>
		);
	}

	/**
	 * 選択肢コンポーネント
	 */
	protected Options: React.FC = props => {
		const { classes } = this.props;
		const options = this.props.optionsAtGrid;

		return (
			<ExpansionPanel defaultExpanded={true} className={classes.options}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography variant="h6" gutterBottom={true}>
						{i18n.t('QuestionnaireGrid_0002')}
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails>
					<div style={{ width: '100%' }}>
						<Table className={classes.optionsTable}>
							<TableBody>
								{options.map(option => (
									<TableRow key={option.replyOrder}>
										<TableCell>
											<Typography align="right">
												{option.replyOrder as number}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography>
												{option.replyText}
											</Typography>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</div>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		);
	};

	/**
	 * ブロックコンポーネント
	 */
	protected Block: React.FC<{
		block: Actions.IQuestionnaireBlock;
	}> = props => {
		const { classes } = this.props;
		const options = this.props.optionsAtGrid;
		const answers = this.state.answers;
		const flg =
			this.props.scoreItemsRegisterFlag === '1' &&
			this.props.respondentCategoryFlg === '1';
		return (
			<ExpansionPanel defaultExpanded={true}>
				<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
					<Typography
						variant="h6"
						className={classes.blockTitle}
						gutterBottom={true}
					>
						{!this.props.assessmentFlg && props.block.blockName}
						{this.props.assessmentFlg &&
							(flg
								? props.block.blockName
								: this.state.careerName)}
					</Typography>
				</ExpansionPanelSummary>
				<ExpansionPanelDetails>
					<div style={{ width: '100%' }}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell />
									<TableCell />
									{options.map(option => (
										<Tooltip
											key={option.replyOrder}
											title={option.replyText}
											placement={'top'}
										>
											<TableCell
												padding="none"
												className={classes.radioCell}
											>
												{option.replyOrder}
											</TableCell>
										</Tooltip>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{props.block.questionnaires.map((q, index) => (
									<Questionnaire
										key={index}
										classes={classes}
										questionnaire={q}
										answerValue={answers[q.questionnaireID]}
										options={options}
										handleRadio={this.handleRadio}
									/>
								))}
							</TableBody>
						</Table>
					</div>
				</ExpansionPanelDetails>
			</ExpansionPanel>
		);
	};

	/**
	 * 提出ボタン、一時保存ボタン
	 */
	protected Buttons: React.FC = myProps => {
		return (
			<Grid
				container={true}
				justify="center"
				spacing={3}
				className={this.props.classes.buttons}
			>
				<Grid item={true}>
					<Fab
						color="primary"
						variant="extended"
						size="large"
						onClick={this.handleReport}
						disabled={this.state.disableReportButton}
					>
						{i18n.t('QuestionnaireGrid_0003')}
					</Fab>
				</Grid>
				<Dialog
					open={this.state.openReportConfirm}
					onClose={this.handleCloseConfirmReport}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="alert-dialog-slide-title">
						{i18n.t('QuestionnaireGrid_0004')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{this.props.assessmentFlg
								? i18n.t('QuestionnaireGrid_0005')
								: i18n.t('QuestionnaireGrid_0006')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleStartReport}
							color="primary"
						>
							{i18n.t('QuestionnaireGrid_0007')}
						</Button>
						<Button onClick={this.handleCloseConfirmReport}>
							　　{i18n.t('QuestionnaireGrid_0008')}
						</Button>
					</DialogActions>
				</Dialog>
				<Dialog
					open={this.state.openReportResult}
					onClose={this.handleCloseReportResult}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="alert-dialog-slide-title">
						　　{i18n.t('QuestionnaireGrid_0009')}
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{this.props.assessmentFlg
								? i18n.t('QuestionnaireGrid_0010')
								: i18n.t('QuestionnaireGrid_0011')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseReportResult}
							color="primary"
						>
							{i18n.t('QuestionnaireGrid_0012')}
						</Button>
					</DialogActions>
				</Dialog>
				{((this.props.assessmentFlg &&
					this.props.displayTmpSaveBtn &&
					this.props.flg === 2) ||
					(!this.props.assessmentFlg &&
						this.props.displayTmpSaveBtn &&
						this.state.previewDisplayTmpSaveBtn &&
						this.props.flg === 0)) && (
					<Grid item={true}>
						<Fab
							color="default"
							variant="extended"
							size="large"
							onClick={this.handleSaveQuestionnaire}
							disabled={this.state.disableReportButton}
						>
							{i18n.t('QuestionnaireGrid_0013')}
						</Fab>
						<Snackbar
							anchorOrigin={{
								horizontal: 'left',
								vertical: 'bottom',
							}}
							open={this.state.saveResultSnackbar}
							autoHideDuration={6000}
							onClose={this.handleSaveResultSnackbarClose}
							ContentProps={{
								'aria-describedby': 'message-id',
							}}
							message={
								<span id="message-id">
									{i18n.t('QuestionnaireGrid_0014')}
								</span>
							}
						/>
					</Grid>
				)}
			</Grid>
		);
	};

	/**
	 * ラジオボタンハンドラ
	 */
	protected handleRadio = (event: React.MouseEvent<HTMLElement>) => {
		const target = event.target as HTMLSelectElement;
		this.state.answers[target.name] = +target.value;
		this.setState({
			answers: this.state.answers,
		});
	};

	/**
	 * 提出ボタン押下ハンドラ
	 */
	protected handleReport = () => {
		this.setState({
			openReportConfirm: true,
		});
	};

	/**
	 * 提出確認ダイアログクローズハンドラ
	 */
	protected handleCloseConfirmReport = () => {
		this.setState({
			openReportConfirm: false,
		});
	};

	/**
	 * 提出開始
	 */
	protected handleStartReport = () => {
		this.setState({
			disableReportButton: true,
			openReportConfirm: false,
		});

		const updatedBlocks = this.makeUpdatedBlocks();
		if (
			this.props.unAnsweredCheck(this.props.mustAnswerFlg, updatedBlocks)
		) {
			this.setState({ disableReportButton: false });
			return;
		}
		if (this.props.preview) {
			this.setState({
				disableReportButton: false,
				openReportResult: true,
			});
			return;
		}

		this.props
			.updateQuestionnaireGrid(this.props.token, {
				blocks: updatedBlocks,
				careerID: this.props.careerID,
				classID: this.props.classID,
				enqueteID: this.props.id,
				isPreview: this.props.preview,
				renewalDate: this.props.renewalDate,
				startTime: this.props.startTime,
				userId: this.props.userAttr.userId,
			})
			.then(result => {
				this.setState({
					disableReportButton: false,
					openReportResult: true,
				});

				if (!this.props.assessmentFlg) {
					// 進捗率更新
					this.props.fetchELearningProgress(this.props.token, {
						careerID: this.props.careerID,
						classID: this.props.classID,
						isPreview: this.props.preview,
						userId: this.props.userAttr.userId,
					});
				}
			});
	};

	/**
	 * 提出確認ダイアログのクローズハンドラ
	 */
	protected handleCloseReportResult = () => {
		const portalFlg = localStorage.getItem('portalFlg');
		if (portalFlg === '0') {
			funcClose();
			if (this.props.assessmentFlg) {
				localStorage.setItem('skillID', this.props.careerID);
				localStorage.setItem('classID', this.props.classID);
			}
			return;
		}
		// this.props.onReported();
		this.setState({
			openReportResult: false,
		});
		if (this.props.preview) {
			this.setState({
				previewDisplayTmpSaveBtn: false,
			});
			return;
		}
		if (!this.props.assessmentFlg) {
			this.props.fetchELearningTree(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				isPreview: this.props.preview,
				userAttr: this.props.userAttr,
			});
		}
		// スキル情報画面に遷移
		if (this.props.assessmentFlg) {
			const to = Routes.getPath(Screens.PERSONAL_SKILL);
			this.props.pushHistory(to);
		} else {
			// アンケート一覧画面に遷移
			if (this.props.onlyQuestionFlg) {
				let to = Routes.getPath(Screens.PERSONAL_QUESTIONNAIRE);
				to = to.replace(/\/:career_id/, `/${this.props.careerID}`);
				to = to.replace(/\/:class_id/, `/${this.props.classID}`);
				this.props.pushHistory(to);
			}
		}
	};

	/**
	 * 一時保存ボタン押下ハンドラ
	 */
	protected handleSaveQuestionnaire = () => {
		this.setState({
			disableReportButton: true,
		});

		const updatedBlocks = this.makeUpdatedBlocks();
		if (this.props.preview) {
			this.setState({
				disableReportButton: false,
				saveResultSnackbar: true,
			});
			return;
		}
		this.props
			.saveQuestionnaireGrid(this.props.token, {
				blocks: updatedBlocks,
				careerID: this.props.careerID,
				classID: this.props.classID,
				enqueteID: this.props.id,
				isPreview: this.props.preview,
				renewalDate: this.props.renewalDate,
				startTime: this.props.startTime,
				userId: this.props.userAttr.userId,
			})
			.then(result => {
				this.setState({
					disableReportButton: false,
					saveResultSnackbar: true,
				});
			});
	};

	/**
	 * 一時保存後のSnackbarクローズハンドラ
	 */
	protected handleSaveResultSnackbarClose = (event: any, reason: any) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ saveResultSnackbar: false });
	};

	/**
	 * 提出、一時保存用に回答の入力を反映したblocksを作成する
	 */
	protected makeUpdatedBlocks() {
		const updatedBlocks: Actions.IQuestionnaireBlock[] = [];
		for (const fromB of this.props.blocks) {
			const toB: Actions.IQuestionnaireBlock = {
				blockID: fromB.blockID,
				blockName: fromB.blockName,
				questionnaires: fromB.questionnaires.map(fromQ => {
					const answer = this.state.answers[fromQ.questionnaireID];
					const toQ: Actions.IQuestionnaire = {
						mustFlg: fromQ.mustFlg,
						questionnaireID: fromQ.questionnaireID,
						questionnaireNo: fromQ.questionnaireNo,
						questionnaireText: fromQ.questionnaireText,
						selectedReply: answer,
					};
					return toQ;
				}),
			};
			updatedBlocks.push(toB);
		}
		return updatedBlocks;
	}

	/**
	 * アンケート情報取得
	 */
	protected fetch() {
		this.props.fetchQuestionnaireGrid(this.props.token, {
			careerID: this.props.careerID,
			classID: this.props.classID,
			enqueteID: this.props.id,
			isPreview: this.props.preview,
			userId: this.props.userAttr.userId,
		});
	}
}

const mapStateToProps = (state: IRootState) => ({
	blocks: state.questionnaire.blocks,
	displayTmpSaveBtn: state.questionnaire.displayTmpSaveBtn,
	enqueteName: state.questionnaire.enqueteName,
	mustAnswerFlg: state.questionnaire.mustAnswerFlg,
	optionsAtGrid: state.questionnaire.optionsAtGrid,
	periodJudgment: state.questionnaire.periodJudgment,
	renewalDate: state.questionnaire.renewalDate,
	respondentCategoryFlg: state.questionnaire.respondentCategoryFlg,
	scoreItemsRegisterFlag: state.questionnaire.scoreItemsRegisterFlag,
	startTime: state.questionnaire.startTime,

	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearQuestionnaireParams: () =>
		dispatch(Actions.clearQuestionnaireParams({})),
	fetchELearningProgress: (
		token: string,
		arg: IFetchELearningProgressParam
	) => {
		const s = ELearningScenarioFactory.createFetchELearningProgress(
			dispatch,
			token
		);
		s.run(arg);
	},
	fetchQuestionnaireGrid: (token: string, arg: IFetchQuestionnaireParam) => {
		const s = ScenarioFactory.createFetchQuestionnaireGrid(dispatch, token);
		s.run(arg);
	},
	saveQuestionnaireGrid: (token: string, arg: ISaveQuestionnaireParam) => {
		const s = ScenarioFactory.createSaveQuestionnaireGrid(dispatch, token);
		return s.run(arg);
	},
	updateQuestionnaireGrid: (
		token: string,
		arg: IUpdateQuestionnaireParam
	) => {
		const s = ScenarioFactory.createUpdateQuestionnaireGrid(
			dispatch,
			token
		);
		return s.run(arg);
	},

	fetchELearningTree: (token: string, arg: IFetchELearningTreeParam) => {
		const s = ELearningScenarioFactory.createFetchELearningTree(
			dispatch,
			token
		);
		s.run(arg);
	},

	doFetchCareerDetail: (token: string, careerID: string) => {
		const s = SearchScenarioFactory.createDoFetchCareerDetail(
			dispatch,
			token
		);
		return s.run(careerID);
	},
	pushHistory: (path: string) => dispatch(push(path)),
});

export interface IQuestionnaireGridProps extends IQuestionnaireProps {
	assessmentFlg: boolean;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IQuestionnaireGridProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(QuestionnaireGrid);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/QuestionnaireGrid.tsx